module.exports = __webpack_public_path__ + "src/assets/img/cmdProg3.70e5f709.svg";